import { render } from "./ChangePasswordDialog.vue?vue&type=template&id=b57f5730&scoped=true"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=js"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=js"

import "./ChangePasswordDialog.vue?vue&type=style&index=0&id=b57f5730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b57f5730"]])

export default __exports__